var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-template',{attrs:{"search-config":_vm.searchConfig,"table-config":_vm.tableConfig,"table-data":_vm.tableData,"total":_vm.total,"loading":_vm.loading,"current-page":_vm.page},on:{"onSearch":_vm.onSearch,"onChangePage":_vm.handleCurrentChange,"onHandle":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }